import React from 'react'
import { Button, TextField } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { change } from '../../../store/actions/account.action'

const Infopago = (props) => {
    const dispatch = useDispatch();
    const { account, error } = useSelector(state => state.accountReducer)

    return (
        <>
            <div className="mb-3">
                <label className="label-custom bs-color-b">Client ID</label>
                <TextField
                    error={(error.infopago_client_id) && true}
                    value={account.infopago_client_id || ''}
                    onChange={e => {
                        dispatch(change({infopago_client_id: e.target.value}))
                        if (error.infopago_client_id && delete error.infopago_client_id);
                    }}
                />

                {(error.infopago_client_id) &&
                    <strong className="text-danger">{error.infopago_client_id[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <label className="label-custom bs-color-b">Client Secret</label>
                <TextField
                    disabled={(props.id)}
                    error={(error.infopago_client_secret) && true}
                    value={account.infopago_client_secret || ''}
                    onChange={e => {
                        dispatch(change({infopago_client_secret: e.target.value}))
                        if (error.infopago_client_secret && delete error.infopago_client_secret);
                    }}
                />

                {(error.infopago_client_secret) &&
                    <strong className="text-danger">{error.infopago_client_secret[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <label className="label-custom bs-color-b">Chave Pix</label>
                <TextField
                    disabled={(props.id)}
                    error={(error.infopago_pix_key) && true}
                    value={account.infopago_pix_key || ''}
                    onChange={e => {
                        dispatch(change({infopago_pix_key: e.target.value}))
                        if (error.infopago_pix_key && delete error.infopago_pix_key);
                    }}
                />

                {(error.infopago_pix_key) &&
                    <strong className="text-danger">{error.infopago_pix_key[0]}</strong>
                }
            </div>
        </>
    )
}


export default Infopago